import { Field, Form, Formik } from "formik";
import React, { useContext, useEffect, useState } from "react";
import { getApi, postApi, putApi } from "../../services/api/globalApi";
import "leaflet/dist/leaflet.css";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router";
import { motion } from "framer-motion";
import * as Yup from "yup";
import Loadning from "./../../components/common/loading/Loading.jsx";
import { FaUser } from "react-icons/fa";
import { context } from "../../context/context.js";
import Input from "../../components/common/inputs/Input.jsx";
import TextArea from "../../components/common/inputs/TextArea.jsx";
import Select from "../../components/common/inputs/Select.jsx";
import {
  userValidate,
  editUserValidate,
} from "../../components/common/validations/userValidte.js";

const User = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { utils, user } = useContext(context);

  console.log(location?.state);
  const [agentData, setAgentData] = useState(null);

  const getAgentInfo = async () => {
    const path = `admin/users/${location?.state?._id}`;
    try {
      const data = await getApi({ path });
      console.log(data?.data.data);
      setAgentData(data?.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const [province, setProvince] = useState([]);

  const getProvince = async () => {
    const params = { notPagination: 1, limit: 50 };
    try {
      const data = await getApi({ path: "admin/utils/provinces", params });
      console.log(data);
      setProvince(data?.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getProvince();
  }, []);

  const formHandler = async (values, { resetForm }) => {
    setShowLoading(true);
    console.log(values);
    values["province"] = values?.province ? values?.province : undefined;
    values["password"] = location?.state ? undefined : values?.password;
    const body = values;
    console.log(body);
    try {
      if (location?.state) {
        const response = await putApi({
          path: `admin/users/${location?.state?._id}`,
          body: JSON.stringify(body),
        });
        toast.success("کاربر با موفقیت ویرایش شد.", {
          position: "top-right",
          closeOnClick: true,
        });
        navigate("/user-list");
        console.log(response);
      } else {
        const response = await postApi({
          path: "admin/users",
          body: JSON.stringify(body),
        });
        console.log(response);
        toast.success("کاربر با موفقیت اضافه شد.", {
          position: "top-right",
          closeOnClick: true,
        });
      }
      resetForm();
      setShowLoading(false);
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.errors[0].message, {
        position: "top-right",
        closeOnClick: true,
      });
      setShowLoading(false);
      // error?.response.status == 401 && showLogutModal();
    }
  };

  const [showLoading, setShowLoading] = useState(false);

  useEffect(() => {
    if (location?.pathname?.slice(7)) {
      getAgentInfo();
    } else {
      setAgentData(null);
    }
  }, [location.pathname]);

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.5 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{
        duration: 0.5,
        // ease: [0, 0.71, 0.2, 1.01]
      }}
      className="w-11/12 mx-auto rounded-lg my-6 bg-white/50 backdrop-blur-sm dark:bg-[#060d26]/50 shadow-lg p-6"
    >
      <h6 className="mb-8 mt-2 text-gray-800 dark:text-white">
        {location.state ? (
          <span className="flex items-center gap-x-2">
            {" "}
            <FaUser size={26} />
            ویرایش کاربر
          </span>
        ) : (
          <span className="flex items-center gap-x-2">
            {" "}
            <FaUser size={26} />
            افزودن کاربر
          </span>
        )}
      </h6>
      {showLoading && <Loadning />}

      <Formik
        enableReinitialize
        initialValues={
          location?.state
            ? {
                name: location?.state?.name,
                // long: location?.state?.long,
                // lat: location?.state?.lat,
                mobile: location?.state?.mobile,
                nationalId: location?.state?.nationalId,
                officeMobile: location?.state?.officeMobile,
                telegramId: location?.state?.telegramId,
                instagramId: location?.state?.instagramId,
                eitaaId: location?.state?.eitaaId,
                province: location?.state?.province?._id,
                role: location?.state?.role,
                status: location?.state?.status,
                father: location?.state?.father,
                birthDate: location?.state?.birthDate,
                backNationalId: location?.state?.backNationalId,
                trackingNationalId: location?.state?.trackingNationalId,
                birthCertificate: location?.state?.birthCertificate,
                postCode: location?.state?.postCode,
                address: location?.state?.address,
                officeAddress: location?.state?.officeAddress,
                bankAccountId: location?.state?.bankAccountId,
                mobile2: location?.state?.mobile2,
                mobile3: location?.state?.mobile3,
                landlineNumber: location?.state?.landlineNumber,
                isReferrer: location?.state?.isReferrer,
                departments: location?.state?.departments || [],
              }
            : {
                name: "",
                // long: "",
                // lat: "",
                mobile: "",
                nationalId: "",
                officeMobile: "",
                telegramId: "",
                instagramId: "",
                eitaaId: "",
                province: "",
                role: "customer",
                status: "active",
                password: "",
                father: "",
                birthDate: "",
                backNationalId: "",
                trackingNationalId: "",
                birthCertificate: "",
                postCode: "",
                address: "",
                officeAddress: "",
                bankAccountId: "",
                mobile2: "",
                mobile3: "",
                landlineNumber: "",
                isReferrer: false,
                departments: [],
              }
        }
        validationSchema={location?.state ? editUserValidate : userValidate}
        onSubmit={formHandler}
      >
        {(formik) => (
          <Form>
            <div className="mt-6">
              <div className="grid gap-6 mb-6 md:grid-cols-2">
                <Input
                  name="name"
                  placeholder="نام و نام خانوادگی"
                  label="نام و نام خانوادگی"
                  type="text"
                />
                <Input
                  name="nationalId"
                  placeholder="کد ملی"
                  label="کد ملی"
                  type="text"
                />
                <Input
                  name="mobile"
                  placeholder="شماره موبایل"
                  label="شماره موبایل"
                  type="text"
                />
                {location?.state ? null : (
                  <Input
                    name="password"
                    placeholder="رمز عبور"
                    label="رمز عبور"
                    type="password"
                  />
                )}
                <Input
                  name="father"
                  placeholder="نام پدر"
                  label="نام پدر"
                  type="text"
                />
                <Input
                  name="birthDate"
                  placeholder="تاریخ تولد"
                  label="تاریخ تولد"
                  type="text"
                />
                <Input
                  name="birthCertificate"
                  placeholder="شماره شناسنامه"
                  label="شماره شناسنامه"
                  type="text"
                />

                <Input
                  name="backNationalId"
                  placeholder="سریال پشت کد ملی"
                  label="سریال پشت کد ملی"
                  type="text"
                />

                <Input
                  name="trackingNationalId"
                  placeholder="کد رهگیری کارت ملی"
                  label="کد رهگیری کارت ملی"
                  type="text"
                />
                <Input
                  name="postCode"
                  placeholder="کد پستی"
                  label="کد پستی"
                  type="text"
                />
                <Input
                  name="bankAccountId"
                  placeholder="شماره حساب"
                  label="شماره حساب"
                  type="text"
                />
                <Input
                  name="landlineNumber"
                  placeholder="شماره ثابت"
                  label="شماره ثابت"
                  type="text"
                />

                <Input
                  name="mobile2"
                  placeholder="شماره موبایل دوم"
                  label="شماره موبایل دوم"
                  type="text"
                />
                <Input
                  name="mobile3"
                  placeholder="شماره موبایل سوم"
                  label="شماره موبایل سوم"
                  type="text"
                />
                <Select name="province" placeholder="استان" label="استان">
                  <option value="">انتخاب استان</option>
                  {province
                    ? province?.map((item, index) => {
                        return (
                          <option key={index} value={item._id}>
                            {item.name}
                          </option>
                        );
                      })
                    : null}
                </Select>

                <Select name="status" placeholder="وضعیت" label="وضعیت">
                  {utils?.USER_STATUS_VALUES?.length
                    ? utils?.USER_STATUS_VALUES.map((item) => {
                        return (
                          <option value={item?.value}>{item?.name}</option>
                        );
                      })
                    : null}
                </Select>

                {user?.role == "admin" && (
                  <>
                    <Select
                      name="isReferrer"
                      value={formik.values["isReferrer"] ? "true" : "false"}
                      onChange={(e) => {
                        formik.setFieldValue(
                          "isReferrer",
                          e.target.value === "true"
                        );
                      }}
                      placeholder="معرف"
                      label="معرف"
                    >
                      <option value="true">بله</option>
                      <option value="false">خیر</option>
                    </Select>

                    <Select name="role" placeholder="نقش" label="نقش">
                      <option value="">انتخاب نقش</option>
                      {utils?.ROLES_VALUES?.length
                        ? utils?.ROLES_VALUES.map((item) => {
                            return (
                              <option value={item?.value}>{item?.name}</option>
                            );
                          })
                        : null}
                    </Select>
                  </>
                )}
              </div>
              <div className="grid gap-4">
                <TextArea
                  name="address"
                  placeholder="آدرس"
                  label="آدرس"
                  type="text"
                />
                <TextArea
                  name="officeAddress"
                  placeholder="ادرس محل کار"
                  label="ادرس محل کار"
                  type="text"
                />
              </div>
              <div className="w-full mt-8">
                <button
                  type="submit"
                  className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                >
                  {location?.state ? "ویرایش کاربر" : "ثبت کاربر"}
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </motion.div>
  );
};

export default User;
